import React from 'react'
import { Link } from "react-router-dom";
import SliderTestimonial from '../../component/SliderTestimonial';


const HomeTestimonial = () => {
    return (
        <>

            <div className="container-fluid features overflow-hidden bg-light py-5" style={{ marginTop: "-10px" }}>
                <div className="container">
                    <div className="section-title text-center mb-5 wow fadeInUp" data-wow-delay="0.1s">
                        <div className="sub-style">
                            <h5 className="sub-title text-primary px-3">Shiv Travels Taxi Services</h5>
                        </div>
                        {/* <h1 className="display-5 mb-4">Why choose us?</h1> */}

                    </div>
                    <div className="row g-4 justify-content-center text-center">
                        <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.1s">
                            <div className="feature-item text-center p-4">
                                <div className="feature-icon p-3 mb-4">
                                    <i className="fa fa-car fa-4x text-primary" />
                                </div>
                                <div className="feature-content d-flex flex-column">
                                    <h5 className="mb-3">Base Kilometer Limit</h5>
                                    <p className="mb-3">There will be a running charge of 250 km per day on all vehicles.</p>
                                    <br />

                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.3s">
                            <div className="feature-item text-center p-4">
                                <div className="feature-icon p-3 mb-4">
                                    <i className="fa fa-credit-card fa-4x text-primary" />
                                </div>
                                <div className="feature-content d-flex flex-column">
                                    <h5 className="mb-3">Extra Charges</h5>
                                    <p className="mb-3">You will be charged extra for every kilometer driven above the 250 km limit.</p>
                                    <br />

                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.5s">
                            <div className="feature-item text-center p-4">
                                <div className="feature-icon p-3 mb-4">
                                    <i className="fa fa-cab fa-4x text-primary" />
                                </div>
                                <div className="feature-content d-flex flex-column">
                                    <h5 className="mb-3">Included Services</h5>
                                    <p className="mb-3"> The daily charge typically covers the vehicle, a driver, fuel, and maintenance. </p>
                                    <br />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.7s">
                            <div className="feature-item text-center p-4">
                                <div className="feature-icon p-3 mb-4">
                                    <i className="fa fa-address-book-o fa-4x text-primary" />
                                </div>
                                <div className="feature-content d-flex flex-column">
                                    <h5 className="mb-3">Overtime</h5>
                                    <p className="mb-3" style={{textAlign:""}}>In addition to extra km, you may also be charged for extended hours beyond the standard hire period.</p>
                                </div>
                            </div>
                        </div>
                       

                    </div>
                </div>
            </div>



        </>
    )
}

export default HomeTestimonial